// based on react-timestamp
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
//
var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
/**
 *
 * @param text
 * @param count
 * @param many
 */
var plural = function (text, count, many) {
    if (count === 1) {
        return text;
    }
    if (!!many) {
        return many;
    }
    return text + "s";
};
/**
 * Timestamp implements the timestamp component.
 *
 * TODO support multiple languages
 */
var Timestamp = /** @class */ (function (_super) {
    __extends(Timestamp, _super);
    /**
     *
     * @param props
     */
    function Timestamp(props) {
        return _super.call(this, props) || this;
    }
    /**
     *
     */
    Timestamp.prototype.componentDidMount = function () {
        if (!!this.props.autoUpdateInterval) {
            var self_1 = this;
            var interval = this.props.autoUpdateInterval * 1000;
            this.intervalID = window.setInterval(function () {
                self_1.forceUpdate();
            }, interval);
        }
    };
    /**
     *
     */
    Timestamp.prototype.componentWillUnmount = function () {
        if (!!this.intervalID) {
            clearInterval(this.intervalID);
            this.intervalID = undefined;
        }
    };
    /**
     *
     */
    Timestamp.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.formatDate(this.props.time)));
    };
    /**
     *
     * @param date
     * @param compareTo
     */
    Timestamp.prototype.distanceOfTimeInWords = function (date, compareTo) {
        var isComparing = false;
        if (!compareTo) {
            compareTo = new Date();
        }
        else {
            isComparing = true;
        }
        var seconds = Math.floor((compareTo.getTime() - date.getTime()) / 1000);
        var isAgo = seconds >= 0;
        seconds = Math.abs(seconds);
        if (!this.props.actualSeconds) {
            if (seconds < 60) {
                // 1 minute
                if (isComparing) {
                    return isAgo ? "Just then" : "Soon";
                }
                else {
                    return "A few seconds";
                }
            }
        }
        var distance;
        var when;
        var precision = this.props.precision || 1;
        if (precision === 1) {
            if (seconds < 60) {
                // 1 minute
                when = "".concat(seconds, " ").concat(plural("second", seconds));
            }
            else if (seconds < 60 * 60) {
                // 1 hour
                distance = Math.round(seconds / 60);
                when = "".concat(distance, " ").concat(plural("minute", distance));
            }
            else if (seconds < 60 * 60 * 24) {
                // 1 day
                distance = Math.round(seconds / (60 * 60));
                when = "".concat(distance, " ").concat(plural("hour", distance));
            }
            else if (seconds < 60 * 60 * 24 * 7) {
                // 1 week
                distance = Math.round(seconds / (60 * 60 * 24));
                when = "".concat(distance, " ").concat(plural("day", distance));
            }
            else if (seconds < 60 * 60 * 24 * (365 / 12)) {
                // 1 month
                distance = Math.round(seconds / (60 * 60 * 24 * 7));
                when = "".concat(distance, " ").concat(plural("week", distance));
            }
            else if (seconds < 60 * 60 * 24 * 30 * 12) {
                // # 1 year
                distance = Math.round(seconds / (60 * 60 * 24 * (365 / 12)));
                when = "".concat(distance, " ").concat(plural("month", distance));
            }
            else {
                return this.prettyTime(date);
            }
        }
        else {
            var whenArr = [];
            // Years
            var YEAR = 60 * 60 * 24 * 365;
            if (seconds > YEAR) {
                distance = Math.floor(seconds / YEAR);
                whenArr.push("".concat(distance, " ").concat(plural("year", distance)));
                seconds -= distance * YEAR;
            }
            // Months
            var MONTH = 60 * 60 * 24 * (365 / 12);
            if (seconds > MONTH) {
                distance = Math.floor(seconds / MONTH);
                whenArr.push("".concat(distance, " ").concat(plural("month", distance)));
                seconds -= distance * MONTH;
            }
            // Days
            var DAY = 60 * 60 * 24;
            if (seconds > DAY) {
                distance = Math.floor(seconds / DAY);
                whenArr.push("".concat(distance, " ").concat(plural("day", distance)));
                seconds -= distance * DAY;
            }
            // Hours
            var HOUR = 60 * 60;
            if (seconds > HOUR) {
                distance = Math.floor(seconds / HOUR);
                whenArr.push("".concat(distance, " ").concat(plural("hour", distance)));
                seconds -= distance * HOUR;
            }
            // Minutes
            var MINUTE = 60;
            if (seconds > MINUTE) {
                distance = Math.floor(seconds / MINUTE);
                whenArr.push("".concat(distance, " ").concat(plural("minute", distance)));
                seconds -= distance * MINUTE;
            }
            if (seconds > 0) {
                whenArr.push("".concat(seconds, " ").concat(plural("second", seconds)));
            }
            when = whenArr.slice(0, precision).join(", ");
        }
        // return final result
        if (isComparing) {
            return when;
        }
        if (isAgo) {
            return "".concat(when, " ago");
        }
        return "in ".concat(when);
    };
    /**
     *
     * @param date
     */
    Timestamp.prototype.prettyTime = function (date) {
        var hours;
        var ampm;
        // eg. 5 Nov 12, 1:37pm
        if (this.props.twentyFourHour) {
            hours = date.getHours();
            ampm = "";
        }
        else {
            if (date.getHours() % 12 === 0) {
                hours = 12;
            }
            else {
                hours = date.getHours() % 12;
            }
            if (date.getHours() > 11) {
                ampm = "pm";
            }
            else {
                ampm = "am";
            }
        }
        var minutes = "".concat((date.getMinutes() < 10 ? "0" : "")).concat(date.getMinutes());
        var day = this.props.includeDay ? DAYS[date.getDay()] + ", " : "";
        switch (this.props.format) {
            case "date":
                return "".concat(day).concat(date.getDate(), " ").concat(MONTHS[date.getMonth()], " ").concat(date.getFullYear());
            case "time":
                return "".concat(hours, ":").concat(minutes).concat(ampm);
            case "full":
            default:
                return "".concat(day).concat(date.getDate(), " ").concat(MONTHS[date.getMonth()]) +
                    "".concat(date.getFullYear(), ", ").concat(hours, ":").concat(minutes).concat(ampm);
        }
    };
    /**
     *
     * @param date
     */
    Timestamp.prototype.formatDate = function (date) {
        if (!date) {
            return "never";
        }
        if (!this.props.format || // default to "ago"
            this.props.format === "ago" ||
            this.props.format === "future" ||
            this.props.format === "relative" ||
            this.props.since ||
            this.props.until) {
            return this.distanceOfTimeInWords(date, this.props.since || this.props.until || undefined);
        }
        return this.prettyTime(date);
    };
    return Timestamp;
}(React.Component));
export { Timestamp };
